<!--sidebar-->
<c-sidebar
  #sidebar1="cSidebar"
  class="d-print-none sidebar sidebar-fixed"
  id="sidebar1"
  visible
>
  <c-sidebar-brand>
    <span> P A M P A M E D </span>
  </c-sidebar-brand>

  <ng-scrollbar pointerEventsMethod="scrollbar">
    <c-sidebar-nav [navItems]="navItems" dropdownMode="close" role="nav" />
  </ng-scrollbar>

  <div class="p-1">
    <button cButton type="button" variant="ghost" class="w-100" (click)="logout()"> Cerrar sesión </button>
  </div>
</c-sidebar>

<!--main-->
<div class="wrapper d-flex flex-column min-vh-100 bg-light dark:bg-transparent">
  <!--app-header-->
  <app-default-header
    class="mb-4 d-print-none z-900 header header-sticky bg-primary"
    position="sticky"
    sidebarId="sidebar1"
  ></app-default-header>
  <!--app-body-->
  <div class="body flex-grow-1 px-0 px-md-1 px-lg-3">
    <c-container fluid class="h-auto">
      <router-outlet></router-outlet>
    </c-container>
  </div>
  <!--app footer-->
  <app-default-footer class="mt-4" style="font-size: 12px;"></app-default-footer>
</div>
